import { Directive, HostListener, Input } from '@angular/core';
import { AnalyticsService } from '../analytics.service';

/** Pass-through to AnalyticsService.logCustom — use on links/buttons for consistent GA4 events. */
export interface GaTrackConfig {
  event: string;
  params?: Record<string, string>;
}

@Directive({
  selector: '[gaTrack]',
  standalone: false,
})
export class GaTrackDirective {
  @Input() gaTrack!: GaTrackConfig;

  constructor(private analytics: AnalyticsService) {}

  @HostListener('click')
  onClick(): void {
    const cfg = this.gaTrack;
    if (!cfg?.event) {
      return;
    }
    this.analytics.logCustom(cfg.event, cfg.params ?? {});
  }
}
